import { useTranslation } from "react-i18next"
import { DocumentLinkButton } from "@/components/chat/DocumentLinkButton"
import { ExportStatusIcon } from "@/components/maps/orderDetails/ExportStatusIcon"
import {
  exportStatusTooltip,
  type ExportStatusClass,
} from "@/components/maps/orderDetails/OrderDetailsDialog"
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"

export type OrderStatus = {
  status: ExportStatusClass | "noOrder"
  exportId?: string
  onOpen?: () => void
}

export const OrderStatusLink = ({ status, exportId, onOpen }: OrderStatus) => {
  const { t } = useTranslation()
  const hasOrder = status !== "noOrder"
  const text = exportStatusTooltip(
    hasOrder,
    status === "noOrder" ? "none" : status,
    exportId,
  )
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          {/* Wrapped so the tooltip still works while the link is disabled
            (no order yet). */}
          <span className="flex">
            <DocumentLinkButton
              label={t("chat.orderStatus.label")}
              onClick={onOpen}
              disabled={!hasOrder || !onOpen}
              aria-label={t("chat.orderStatus.ariaLabel", { status: text })}
              data-testid="driver-overview-order-status"
              data-status={status}
              trailing={
                <ExportStatusIcon
                  status={status === "noOrder" ? "none" : status}
                  className="h-3.5 w-3.5"
                />
              }
            />
          </span>
        </TooltipTrigger>
        <TooltipContent side="left">{text}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

export default OrderStatusLink
